import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import { PriceOverridesProvider } from './context/PriceOverridesContext';
import { PromotionAnnouncements } from './components/menu/MenuHighlights';

const SandwichMenuPage = lazy(() => import('./pages/SandwichMenuPage'));
const DeliMenuPage = lazy(() => import('./pages/DeliMenuPage'));
const DrinksPage = lazy(() => import('./pages/DrinksPage'));
const SnacksPage = lazy(() => import('./pages/SnacksPage'));
const CateringPage = lazy(() => import('./pages/CateringPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const MiniGamesPage = lazy(() => import('./pages/MiniGamesPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));

const RouteFallback = () => (
  <div style={{ minHeight: '60vh' }} aria-hidden="true" />
);

const SiteFrame = ({ children }) => {
  const admin = useLocation().pathname === '/admin';
  return <div className={admin ? 'App admin-app' : 'App'}>{!admin && <Header />}<main>{!admin && <PromotionAnnouncements />}{children}</main>{!admin && <Footer />}</div>;
};

function App() {
  return (
    <PriceOverridesProvider>
      <Router>
        <SiteFrame>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/menu" element={<SandwichMenuPage />} />
                <Route path="/deli" element={<DeliMenuPage />} />
                <Route path="/drinks" element={<DrinksPage />} />
                <Route path="/snacks" element={<SnacksPage />} />
                <Route path="/catering" element={<CateringPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/games" element={<MiniGamesPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/sandwich-3d" element={<Navigate to="/menu" replace />} />
              </Routes>
            </Suspense>
        </SiteFrame>
      </Router>
    </PriceOverridesProvider>
  );
}

export default App;
